import { ProCard, ProDescriptions } from '@ant-design/pro-components'
import { FindingsAlert, FindingsSelector } from '@app/icare/components/findings'
import { selectByGroup } from '@app/icare/entities/patient/queries/patientFindingsQueryOptions'
import { patientQueryOptions } from '@app/icare/entities/patient/queries/patientQueryOptions'
import { CareLevelEnum } from '@app/icare/entities/patient/schema/PatientCareLevel'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { MedicalSupplyAccessTypeEnum } from '@app/icare/entities/patient/schema/PatientMedicalSupplyAccess'
import { MobilityEnum } from '@app/icare/entities/patient/schema/PatientMobility'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { entityParams } from '@pkg/db/utils'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Flex } from 'antd'
import dayjs from 'dayjs'

export const Route = createFileRoute('/_app/patienten/$id/_edit/anamnese/')({
  params: entityParams({ id: PatientId }),
  loader: ({ params, context: { queryClient } }) => queryClient.ensureQueryData(patientQueryOptions(params.id)),
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const { data } = useSuspenseQuery(patientQueryOptions(id))

  const careLevels = data?.careLevels ?? []
  const weights = data?.weights ?? []
  const mobilities = data?.mobilities ?? []
  const access = data?.medicalSupplyAccess ?? []

  const latestCareLevel = [...careLevels].sort((a, b) => dayjs(b.activeFrom).diff(dayjs(a.activeFrom)))[0]
  const latestWeight = [...weights].sort((a, b) => dayjs(b.activeFrom).diff(dayjs(a.activeFrom)))[0]
  const latestMobility = [...mobilities].sort((a, b) => dayjs(b.activeFrom).diff(dayjs(a.activeFrom)))[0]
  const latestAccess = [...access].sort((a, b) => dayjs(b.activeFrom).diff(dayjs(a.activeFrom)))[0]

  const diagnosis = data?.anamnesis?.diagnosis
  const height = data?.personal?.height

  return (
    <Flex vertical gap="small">
      <FindingsSelector selector={selectByGroup('anamnesis')}>{f => <FindingsAlert findings={f} />}</FindingsSelector>
      <ProCard title={<Trans>Zusammenfassung</Trans>}>
        <ProDescriptions column={2}>
          <ProDescriptions.Item label={t`Hauptdiagnose`}>
            {diagnosis && diagnosis.length > 0 ? diagnosis.map(d => d.value).join(', ') : '-'}
          </ProDescriptions.Item>
          <ProDescriptions.Item label={t`Körpergröße`}>{height != null ? `${height} cm` : '-'}</ProDescriptions.Item>
          <ProDescriptions.Item label={t`Aktueller Pflegegrad`}>
            {latestCareLevel?.level ? CareLevelEnum.$.getLabel(latestCareLevel.level) : '-'}
          </ProDescriptions.Item>
          <ProDescriptions.Item label={t`Aktuelles Gewicht`}>
            {latestWeight?.weight != null ? `${latestWeight.weight} kg` : '-'}
          </ProDescriptions.Item>
          <ProDescriptions.Item label={t`Aktuelle Mobilität`}>
            {latestMobility?.mobility ? MobilityEnum.$.getLabel(latestMobility.mobility) : '-'}
          </ProDescriptions.Item>
          <ProDescriptions.Item label={t`Aktuelle Zugänge`}>
            {latestAccess?.access ? MedicalSupplyAccessTypeEnum.$.getLabel(latestAccess.access) : '-'}
          </ProDescriptions.Item>
        </ProDescriptions>
      </ProCard>
    </Flex>
  )
}
